import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är kunskapsprovet i alkohollagen?";
const SHORT_ANSWER = "Det är ett skriftligt prov hos kommunen som visar att du har tillräckliga kunskaper i alkohollagstiftningen för att bedriva alkoholservering.";

export const Route = createFileRoute("/fraga/vad-ar-kunskapsprovet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är kunskapsprovet i alkohollagen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Provet regleras i FoHMFS 2014:7 och täcker områden som tillstånd, servering, ordning, marknadsföring, tillsyn och sanktioner. Det görs digitalt i Folkhälsomyndighetens system med slumpade frågor."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – komplett guide" }}
      related={[{"to": "/fraga/hur-manga-fragor-har-provet", "label": "Hur många frågor har kunskapsprovet?"}, {"to": "/fraga/hur-manga-ratt-kravs", "label": "Hur många rätt krävs på kunskapsprovet?"}, {"to": "/fraga/vad-skiljer-erinran-fran-varning", "label": "Vad är skillnaden mellan erinran och varning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är kunskapsprovet i alkohollagen?" },
      { name: "description", content: "Det är ett skriftligt prov hos kommunen som visar att du har tillräckliga kunskaper i alkohollagstiftningen för att bedriva alkoholservering." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-kunskapsprovet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-kunskapsprovet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-kunskapsprovet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är kunskapsprovet i alkohollagen", url: "https://alkoholprovet.se/fraga/vad-ar-kunskapsprovet" },
      ]),
    ],
  }),
});
